import { Button, CompassLineIcon, Empty } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import type { ChannelScope } from 'features/channels/models';

type P = {
  navigateToJoined?: () => Promise<void>;
  scope: ChannelScope;
};

const ChannelsEmpty = ({ navigateToJoined, scope }: P) => {
  const getButtonTitle = () => {
    switch (scope) {
      case 'communities':
        return 'Go to Communities';
      case 'events':
        return 'Go to Calendar';
      case 'givings':
        return 'Go to Givings';
      case 'programs':
        return 'Go to Programs';
      case 'videos':
        return 'Go to Videos';
    }
  };

  return (
    <Empty
      description={{
        subtitle: 'There is nothing available for this channel yet or you’ve joined all the content already',
        title: 'This channel is empty',
      }}
      image={<CompassLineIcon />}
    >
      {/* TODO maybe move to `Empty` as new option */}
      <Button onClick={navigateToJoined} size="large" type="link-primary">
        {getButtonTitle()}
      </Button>
    </Empty>
  );
};

export default ChannelsEmpty;
